import { render, staticRenderFns } from "./PromotionCreateDialog.vue?vue&type=template&id=27b31fa2&scoped=true"
import script from "./PromotionCreateDialog.vue?vue&type=script&lang=ts"
export * from "./PromotionCreateDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b31fa2",
  null
  
)

export default component.exports